import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Auth as awsAuth, Hub } from 'aws-amplify';
import { auth as firebaseAuth, firestore, userRepo } from '../services/auth/firebase/firebase';
import {
  fetchStart,
  fetchSuccess,
  getUserObject,
} from '../../redux/actions';
import { AuthType } from '../../shared/constants/AppEnums';
import jwtAxios from '../services/auth/jwt-auth/jwt-api';
import { AppState } from '../../redux/store';
import { UPDATE_AUTH_USER } from '../../types/actions/Auth.actions';
import { AuthUser } from '../../types/models/AuthUser';
import { createFabmanMember, getFabmanMemberPrivileges, getFabmanMembers } from '@crema/services/apis/fabman';
import LogRocket from 'logrocket';

export const useAuthToken = (): [boolean, AuthUser | null] => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { user } = useSelector<AppState, AppState['auth']>(({ auth }) => auth);

  useEffect(() => {

    const firebaseCheck = () =>
      new Promise<void>(resolve => {
        firebaseAuth.onAuthStateChanged(async authUser => {

          try {
            LogRocket && LogRocket.identify('authUser.email', {
              // name: authUser.firstName + ' ' + authUser.lastName,
              email: authUser?.email || '',
              id: authUser?.uid || ''
            });
          } catch (e) { console.error("Error in Logrocket AppHooks " + e); }
          if (authUser) {

            let user = await userRepo.get(authUser.uid)//.then(user => {

            let authUserObj = getUserObject(authUser, user);


            if (!user?.fabmanMember?.id) {
              //TODO: it may have been deleted. if so or user is blocked for whatever reason, disallow member from logging in
              // otherwise, create fabman member => this will happen if the member was accidentally deleted from fabman, or if the user was never created via this app

              console.error(`[st] User found, but no fabman member`);
              let fabmanMember = await createFabmanMember(user);

              if (!fabmanMember.id) {
                console.error(`[st] create fabman returned without fabmanmember ${JSON.stringify(user) } `)
                // let await getFabmanMembers({email: user.email});

              }

              user.fabmanMember = fabmanMember;
              if (fabmanMember.id) {
                await firestore.doc(`/users/${user.id}`).set({ fabmanMember: JSON.parse(JSON.stringify(fabmanMember)), member: fabmanMember.id }, { merge: true });
              }


              dispatch(fetchSuccess());
              authUserObj.userProfile = user;
              // dispatch({ type: UPDATE_AUTH_USER, payload: authUserObj });

            }
            let privileges = await getFabmanMemberPrivileges(user.fabmanMember?.id)
            if (!privileges || privileges.length == 0) {
              console.error(`[st] No privileges returned for member : ${JSON.stringify(user)}`)
            } else if (privileges[0] == "admin" || privileges[0] == "owner") {
              if (!user.permissions?.includes('ADMIN')) {
                try {


                  await firestore.doc(`users/${user.id}`).update('permissions', ['ADMIN']);
                  user.permissions = ['ADMIN'];
                  authUserObj.userProfile = user;
                  // dispatch({ type: UPDATE_AUTH_USER, payload: authUserObj });

                } catch (error: any) {
                  console.error(`[st] Error updating permissions from user to ADMIN: ${error}`);
                }
              }
            } else if (privileges[0] == "member") {
              if (user.permissions?.includes('ADMIN')) {
                try {
                  await firestore.doc(`users/${user.id}`).update('permissions', ['MEMBER']);
                  user.permissions = ['MEMBER'];
                  authUserObj.userProfile = user;
                  // dispatch({ type: UPDATE_AUTH_USER, payload: authUserObj });

                } catch (error: any) {
                  console.error(`[st] Error updating permissions from user to MEMBER: ${error}`)
                }
              }

            }

            dispatch(fetchSuccess());
            dispatch({
              type: UPDATE_AUTH_USER,
              payload: authUserObj,
            });
            // })

          }
          resolve();
        });
        return Promise.resolve();
      });

    const checkAuth = () => {
      Promise.all([firebaseCheck(),
      ]).then(() => {
        setLoading(false);
      });

    };
    checkAuth();
  }, [dispatch]);

  return [loading, user];
};


export const useAuthUser = (): AuthUser | null => {
  const { user } = useSelector<AppState, AppState['auth']>(({ auth }) => auth);
  if (user) {
    return user;
  }
  return null;
};
